import React from "react";
import ExploreProvider from "../components/general/ExploreProvider";
import { SubHeader } from "../components/general/Header";

const RequestExporeProvider = () => {
  return (
    <main className="w-screen min-h-screen flex bg-page flex-col md:items-center  ">
      <div className=" p-3 md:w-1/3  bg-white ">
        <div className="space-y-4 p-3 rounded-lg h-screen">
          <ExploreProvider />
        </div>
      </div>
    </main>
  );
};

export default RequestExporeProvider;
